import { render, staticRenderFns } from "./fieldOneToManyGlobal.vue?vue&type=template&id=fdf4c798&"
import script from "./fieldOneToManyGlobal.vue?vue&type=script&lang=js&"
export * from "./fieldOneToManyGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports